import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'components/_new/Button/Button';
import { useMaintenance } from 'hooks/useMaintenance';
import { dateFormat } from 'utils/dateFormat';
import { Dialog } from './_new/Dialog';

export const MaintenanceNotification = () => {
	const { t } = useTranslation();
	const [dialogVisible, setDialogVisible] = useState(false);
	const [dontShowAgainChecked, setDontShowAgainChecked] = useState(false);

	const { scheduledDate, showNotification, dismissNotification, setDontShowAgain, getDontShowAgain } =
		useMaintenance();

	useEffect(() => {
		setDontShowAgainChecked(getDontShowAgain());
	}, [getDontShowAgain]);

	useEffect(() => {
		if (showNotification) {
			setDialogVisible(true);
		}
	}, [showNotification]);

	const formattedDate = useMemo(() => {
		if (!scheduledDate) {
			return null;
		}
		return dateFormat(scheduledDate, 'full');
	}, [scheduledDate]);

	const openDialog = () => setDialogVisible(true);

	const closeDialog = () => {
		setDialogVisible(false);
		dismissNotification();
		setDontShowAgain(dontShowAgainChecked);
	};

	if (!scheduledDate) {
		return null;
	}

	return (
		<>
			<div
				className="fixed right-0 top-50 z-5"
				style={{
					transform: 'translateY(-50%)',
				}}
			>
				<Button
					onClick={openDialog}
					variant="primary"
					icon="tools"
					label={t('maintenance.notification.title')}
					iconOnly
					tooltip={t('maintenance.notification.title')}
					tooltipPosition="left"
				/>
			</div>
			<Dialog title={t('maintenance.notification.title')} visible={dialogVisible} onHide={closeDialog}>
				<div className="flex flex-column gap-3">
					<p className="m-0">{t('maintenance.notification.message', { date: formattedDate })}</p>
					<p className="m-0 text-sm text-color-secondary">{t('maintenance.notification.info')}</p>

					<div className="flex flex-row align-items-center justify-content-between gap-2 mt-2">
						<div className="flex flex-row gap-2">
							<Checkbox
								inputId="dontShowAgainMaintenance"
								checked={dontShowAgainChecked}
								onChange={(e) => setDontShowAgainChecked(e.checked || false)}
							/>
							<label htmlFor="dontShowAgainMaintenance" className="cursor-pointer m-0">
								{t('maintenance.notification.dontShowAgain')}
							</label>
						</div>
						<Button label={t('actions.close')} onClick={closeDialog} variant="primary" />
					</div>
				</div>
			</Dialog>
		</>
	);
};
